<template>
  <el-dialog
    :visible.sync="modelValue"
    width="506px"
    title
    append-to-body
    custom-class="relic-upload-choose-photo"
  >
    <div class="photo-title font-h3">选择相册封面</div>
    <div class="photo-imgs">
      <div
        v-for="(item, imgIndex) in photoAlbum"
        :key="imgIndex"
        class="photo-imgs-item"
      >
        <img :src="item.thumb" alt />
        <div
          @click="handleChooseCoverImgUrl(imgIndex)"
          class="choose-btn"
          :class="isChoosed === imgIndex ? 'isChoosed' : ''"
        >
          设为
          <br />封面
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="modelValue = false">取 消</el-button>
      <el-button type="primary" @click="handleSaveCoverUrl">保存</el-button>
    </div>
    <relic-upload-cropper-vue
      v-model="showCropper"
      :imgUrl="coverImgUrl"
      v-if="coverImgUrl"
      @onCancelUpdateCover="handleCancelUpdateCover"
      @onPhotoAlibumUpdateCover="handleSuccessUpdateCover"
    />
  </el-dialog>
</template>

<script>
import { modelMixin } from '../../../assets/js/mixins/model';
import relicUploadCropperVue from './relic-upload-cropper.vue';
export default {
  name: 'RelicUploadChoosePhoto',
  props: {
    photoAlbum: {
      type: Array,
      default: () => []
    }
  },
  components: {
    relicUploadCropperVue
  },
  mixins: [modelMixin],
  data() {
    return {
      isChoosed: '',
      imgList: [
        {
          src:
            'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1598010344077&di=f4c8a83fa689281b8262da4ffe2abe65&imgtype=0&src=http%3A%2F%2Fa0.att.hudong.com%2F56%2F12%2F01300000164151121576126282411.jpg'
        }
      ],
      showCropper: false,
      coverImgUrl: ''
    };
  },
  methods: {
    /**
     * 监听取消更新回掉
     */
    handleCancelUpdateCover() {
      this.modelValue = false;
      this.$emit('onCancelPhotoCover');
    },
    /**
     * 选择图片为封面
     */
    handleChooseCoverImgUrl(imgIndex) {
      // this.isChoosed = this.isChoosed === imgIndex ? '' : imgIndex;
      if (this.isChoosed !== imgIndex) {
        this.coverImgUrl = this.photoAlbum[imgIndex].url;
        this.isChoosed = imgIndex;
      } else if (this.isChoosed === imgIndex) {
        this.coverImgUrl = '';
        this.isChoosed = '';
      }
    },
    /**
     * 保存url
     */
    handleSaveCoverUrl() {
      if (this.coverImgUrl) {
        this.showCropper = true;
      } else {
        this.$prompt('未选择封面');
      }
    },
    /**
     * 监听上传成功
     */
    handleSuccessUpdateCover() {
      this.$emit('onPhotoAlbumSuccessCover');
      this.modelValue = false;
    }
  }
};
</script>

<style lang="scss">
.relic-upload-choose-photo {
  .el-dialog {
    &__header {
      padding: 0;
    }
    &__body {
      padding: 28px 24px;
      height: 600px;
      max-height: 80vh;
      overflow-y: auto;
    }
    &__headerbtn {
      display: flex;
      font-size: 30px;
      color: #fff;
      top: -5px;
      right: -40px;
    }
    &__close {
      color: #fff;
    }
  }
  .photo-title {
    padding-bottom: 20px;
    font-size: 16px;
  }
  .photo-imgs {
    display: flex;
    flex-wrap: wrap;
    &-item {
      position: relative;
      width: 200px;
      height: 143px;
      // margin-left: 15px;
      margin: 5px 10px;
      img {
        width: 200px;
        height: 143px;
      }
      .choose-btn {
        position: absolute;
        width: 75px;
        height: 43px;
        text-align: center;
        line-height: 21px;
        color: #fff;
        background-color: rgba(0, 0, 0, 0.3);
        bottom: 0px;
        right: 0px;
        z-index: 200;
      }
      .isChoosed {
        background-color: $color-primary;
      }
    }
  }
}
</style>
